import { Injectable } from '@angular/core';

import { BaseComponentResolver } from '@services/_base/base-component-resolver/base-component-resolver';
import { DocumentResolver } from '@services/resolvers/auxiliary/document-resolver';

import { CmsComponentConfig, Widget } from '@interfaces/config';
import { ParagraphWidgetData } from '@generated/content';

@Injectable({
  providedIn: 'root',
})
export class WidgetComponentResolver extends BaseComponentResolver {
  static override instance: WidgetComponentResolver;
  private readonly componentType = Widget.TypeEnum;

  static getInstance(): WidgetComponentResolver {
    return (WidgetComponentResolver.instance ||= new WidgetComponentResolver());
  }

  public override resolveComponentConfig(node: ParagraphWidgetData): CmsComponentConfig<Widget.ComponentConfig> | null {
    if (node?.attributes?.field_display_widget !== 'yes') {
      return null;
    }

    const documentNodeId = node.relationships?.field_dcoument_widget?.data?.id;

    if (!documentNodeId) {
      return null;
    }

    const { href, target } = DocumentResolver.buildDocumentTarget(documentNodeId);

    return {
      componentType: this.componentType,
      config: {
        nodeId: BaseComponentResolver.getNodeId(node),
        enabled: true,
        link: { href, target },
      },
    };
  }
}
